import { filterInvalidComponents } from './filterInvalidComponents';
import type { PagesToExclude } from './filterInvalidComponents';

/** The excluded members that stay excluded on the guest custom page. */
type GuestExcluded = Exclude<PagesToExclude, { __typename?: 'PlacesMapComponent' }>;

/**
 * `filterInvalidComponents` excludes `PlacesMapComponent` because the surfaces
 * sharing it — notably the admin website editor — don't select its fields and
 * have no renderer for it, so it broke `sortBySortOrder` (#17402).
 *
 * The guest custom page is different: it selects the component's fields
 * (`GuestPlacesMapComponent`, including `sortOrder`) and renders it, so it opts
 * back in here rather than changing the shared filter and pushing an
 * unrenderable component into the editor. Fold this back into the shared filter
 * once the admin surface can render a places map too.
 */
export const isGuestRenderableComponent = <T extends { __typename?: string }>(component: T): component is Exclude<T, GuestExcluded> => {
  if (component.__typename === 'PlacesMapComponent') {
    return true;
  }
  return filterInvalidComponents(component);
};
